<template>
  <div class="place">
    <!-- hack: background movie switch out -->
    <main-content
      v-if="activePage.backgroundImage"
      :background-image="activePage.backgroundImage === 'misc/AL_MOUJ_BRAND_MOVIE_MARCH_2020.mp4' && language.code === 'ar' ? 'misc/AL_MOUJ_BRAND_MOVIE_MARCH_2020_AR.mp4' : activePage.backgroundImage"
      right-sidebar="true"
    >
      <!-- issuu modal -->
      <transition name="fast-fade">
        <div v-if="isIssuuModalActive" class="issuu" @click.stop="$emit('toggleIssuuModal')">
          <div class="issuu__inner">
            <div class="issuu__control-overlay"></div>
            <div style="position:relative;padding-top:max(40%,326px);height:0;width:100%;" @click.stop="">
              <iframe sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox" allowfullscreen="true" style="position:absolute;border:none;width:100%;height:100%;left:0;right:0;top:0;bottom:0;" :src="activePage.issuuEmbedUrl"></iframe>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fast-fade">
        <video-player 
          v-if="video"
          :source="video"
          @close="video = null"
        ></video-player>
      </transition>
    <!-- <img :src="require('@/assets/cloud.png')" class="place__cloud"> -->
    <div class="place__tag-layer">
      <transition :name="activePage.verticalSlider ? 'fade-in-left' : 'fade-in-up'" :key="'updateSlider' + language.rtl">
        <div
          v-if="showSlider"
          class="place__tag-slider"
          :class="{ 'place__tag-slider--vert': activePage.verticalSlider }"
        >
          <div class="place__tag-slider-controls" v-show="referenceTagsSlider.length > 3">
            <div class="place__tag-slider-prev"><fa :icon="['far', 'chevron-left']"/></div>
            <div class="place__tag-slider-next"><fa :icon="['far', 'chevron-right']"/></div>
          </div>
          <tiny-slider 
            v-bind="activePage.verticalSlider ? verticalTinySliderOptions : tinySliderOptions"
            class="place__tiny-slider"
            @dragMove="handleSliderDrag"
            @dragEnd="handleSliderDragEnd"
          >
            <div v-for="tag in referenceTagsSlider" :key="tag._id">
              <div class="slide" :class="{ 'slide--reverse' : language.rtl }">
                <div class="slide__image-wrapper">
                  <div v-show="!tag.hideTagReference" class="slide__image-reference">{{ tag.referenceIndex }}</div>
                  <img class="slide__image" :src="`${$store.state.assetsPath}${tag.asset.customThumbPath ? tag.asset.customThumbPath : tag.asset.thumbPath}`" alt="">
                  <div
                    v-if="tag.asset.path && tag.asset.type === 'video'"
                    class="slide__video-circle-wrapper"
                    :class="{ 'slide__video-circle-wrapper--active': tag.asset.path === video }"
                  >
                    <fa :icon="['fad', 'play-circle']" @click="setVideo(tag.asset.path)" />
                  </div>
                </div>
                <div class="slide__content" :class="{ 'dir-rtl' : language.rtl }">
                  <div class="slide__heading" v-html="tag.label[language.code]"></div>
                  <div class="slide__description" v-html="tag.description[language.code]"></div>
                </div>
              </div>
            </div>       
          </tiny-slider>
        </div>
      </transition>
      <transition-group
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="afterLeave"
      >
        <template v-for="(tag, index) in tags" tag="div">
          <tag-basic v-if="tag.type === 'basic'" :data-index="index" :key="`basic-${tag._id}`" v-bind="tag" :lang="language.code"></tag-basic>
          <tag-box v-if="tag.type === 'box'" :data-index="index" :key="`box-${tag._id}`" v-bind="tag" :lang="language.code"></tag-box>
          <tag-rich v-if="tag.type === 'rich'" :data-index="index" :key="`rich-${tag._id}`" v-bind="tag" :rtl="language.rtl" :lang="language.code"></tag-rich>
          <tag-reference v-if="tag.type === 'reference' && !tag.hideTagReference" :data-index="index" :key="`ref-${tag._id}`" :pos="tag.pos" :label="tag.referenceIndex" :tail-position="tag.tailPosition"></tag-reference>
        </template>
      </transition-group>
    </div>
    </main-content>
  </div>
</template>
<script>
import MainContent from '@/components/MainContent'
import TagBasic from '@/components/TagBasic'
import TagBox from '@/components/TagBox'
import TagRich from '@/components/TagRich'
import TagReference from '@/components/TagReference'
import TinySlider from 'vue-tiny-slider'
import VideoPlayer from '@/components/VideoPlayer'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'place',
  
  components: { MainContent, TagBasic, TagBox, TagRich, TagReference, TinySlider, VideoPlayer },

  props: ['isIssuuModalActive'],

  data () {
    return {
      animating: false,
      showSlider: false,
      tags: [],
      tinySliderOptions: {
        mouseDrag: true,
        controlsContainer: '.place__tag-slider-controls',
        loop: false,
        items: 3,
        gutter: 0,
        nav: false,
        speed: 600,
        swipeAngle: 45
      },
      verticalTinySliderOptions: {
        axis: 'vertical',
        mouseDrag: true,
        controlsContainer: '.place__tag-slider-controls',
        loop: false,
        items: 2,
        gutter: 0,
        nav: false,
        speed: 600,
        swipeAngle: 45        
      },
      video: null,
    }
  },

  computed: {
    ...mapGetters([
      'activePage',
      'activeSubNavigation'
    ]),

    referenceTags () {
      let refTags = _.filter(this.tags, tag => {
        if (tag.type === 'reference') {
          return true
        }
      })

      // if (this.language.rtl) {
      //   refTags = _.orderBy(refTags, ['order', 'pos.x'], ['desc'])
      //   refTags.forEach((tag, index) => {
      //     if (!tag.hideTagReference) {
      //       tag.referenceIndex = index + 1
      //     }
      //   })
      //   return _.reverse(refTags)
      // } else {
        refTags = _.orderBy(refTags, ['order', 'pos.x'], ['asc'])
        refTags.forEach((tag, index) => {
          if (!tag.hideTagReference) {
            tag.referenceIndex = index + 1
          }
        })
        return refTags
      //}
    },

    referenceTagsSlider () {
      let refTags = _.filter(this.tags, tag => {
        if (tag.type === 'reference') {
          return true
        }
      })

      refTags = _.orderBy(refTags, ['order', 'pos.x'], ['asc'])

      // if (this.language.rtl) {
      //   let startingIndex = refTags.length

      //   refTags.forEach(tag => {
      //     if (!tag.hideTagReference) {
      //       tag.referenceIndex = startingIndex--
      //     }
      //   })
      //   return refTags
      // } else {
        refTags.forEach((tag, index) => {
          if (!tag.hideTagReference) {
            tag.referenceIndex = index + 1
          }
        })
        return refTags
      // }
    },

    sidebarContentKey () {
      return this.activePage.label + this.activePage.description
    },

    sidebarNavigationItems () {
      let sidebarNavigationItems = []
      this.activeSubNavigation.forEach(_item => {
        let item = {
          to: `/category/${this.$store.state.route.params.categoryId}/page/${_item.pageId}`,
          label: _item.label,
          icon: _item.icon
        }
        sidebarNavigationItems.push(item)
      })
      return sidebarNavigationItems
    },

    sidebarNavigationKey () {
      return JSON.stringify(this.activeSubNavigation)
    },

    language () {
      return this.$store.getters.language
    }
  },

  mounted () {
    this.setTags()
  },

  watch: {
    activePage () {
      this.setTags()
    },

    $route () {
      this.video = null
    }
  },

  methods: {
    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el) {
      const defaultStaggerTimeout = 300
      const maxTotalStaggerTime = 1000
      const adjustedStaggerTimeout = maxTotalStaggerTime / this.tags.length + 1
      const staggerTimeout = Math.min(defaultStaggerTimeout, adjustedStaggerTimeout)

      setTimeout(() => {
        // TODO: set animating as a global state so we can also turn off the bottom bar navigation
        // this.animating = true
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s, opacity 0.6s`
        // if (el.dataset.index == this.tags.length - 1) {
        //   this.animating = false
        // }
      }, (parseInt(el.dataset.index) + 2) * staggerTimeout)
    },

    afterLeave (el) {
      el.style.opacity = 0
      el.style.transition = `transform 0.3s, opacity 0.3s`
    },

    setTags () {
      this.showSlider = false
      this.tags = null
      this.$nextTick(() => {
        if (this.activePage.tags) {
          this.tags = _.sortBy(this.activePage.tags, tag => { return tag.pos.x })
        } else {
          this.tags = null
        }
        if (this.referenceTags.length) {
          setTimeout(() => {
            this.showSlider = true
          }, 500)
        }
      })
    },

    setVideo (video) {
      if (this.video === video) {
        this.video = null
      } else {
        this.video = video
      }
    },

    handleSliderDrag () {
      this.isSliderDragging = true
      if (this.dragTimeout === null) {
        this.dragTimeout = setTimeout(() => {
          this.dragTimeout = null
          this.isSliderDragging = false
        }, 1000) 
      }
    },

    handleSliderDragEnd () {
      this.dragTimeout = null
      this.isSliderDragging = false
    },
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "node_modules/tiny-slider/src/tiny-slider";

.sidebar__spacer {
  flex-grow: 1;
  height: 100%;
}
.place {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &__tag-slider-controls {
    color: $gold;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    font-size: 8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2.75rem 0 4.25rem;

    div {
      transition: opacity 0.3s;

      &[aria-disabled=true] {
        opacity: 0.2;
      }
    }
  }

  &__tiny-slider {
    // display: flex;
  }

  &__tag-slider {
    background: $white;
    bottom: 0;
    position: absolute;
    width: 152rem;
    height: 23.25rem;
    padding: 2.35rem 8rem 2.4rem 9.8rem;

    .slide {
      display: flex;
      padding: 0 2rem;

      &--reverse {
        flex-direction: row-reverse;

        .slide__content {
          padding: 0 1rem 0 0;
        }
      }

      &__image-wrapper, &__content {
        position: relative;
        width: 50%;
      }

      &__image-reference {
        background-color: #000;
        border-radius: 1.5rem;
        display: flex;
        font-family: 'Nexa';
        justify-content: center;
        align-items: center;
        margin: 0.5em;
        font-size: 1.5rem;
        position: absolute;
        top: 0;
        left: 0;
        height: 3rem;
        width: 3rem;

        .ar & {
          font-family: 'GE Dinkum';
        }        
      }

      &__content {
        color: $black;
        padding-left: 1rem;
      }

      &__image {
        height: 18.5rem;
        object-fit: cover;
        width: 20rem;
      }

      &__heading {
        font-family: 'Nexa';
        font-size: 1.4rem;
        font-weight: 400;
        margin-bottom: 0.5em;
        letter-spacing: 0.05em;
        line-height: 1.1;

        .ar & {
          font-family: 'GE Hili';
        }        
      }

      &__description {
        font-family: 'Nexa';
        font-size: 1.25rem;
        font-weight: 200;
        line-height: 1.2;
        letter-spacing: 0.05em;

        .ar & {
          font-family: 'GE Dinkum';
        }        
      }

      &__video-circle-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          height: 10rem;
          opacity: .9;
          transition: transform 0.3s;
          width: 10rem;
        }

        &--active {
          svg {
            opacity: 1;
            transform: scale(1.1) rotate(-90deg);
          }
        }
      }
    }

    &--vert {
      right: 0;
      height: 100%;
      padding: 14rem 2rem 8rem;
      width: 24rem;

      .place__tag-slider-controls {
        bottom: 0;
        color: $gold;
        font-size: 4rem;
        height: 8rem;
        top: unset;
        padding: 0;
      }

      .place__tag-slider-prev, .place__tag-slider-next {
        padding: 2rem 5rem;
        transform: rotate(90deg);
      }

      .slide {
        display: block;
        height: 37.5rem;
        padding: 0;

        &__image-wrapper, &__content {
          position: relative;
          width: 100%;
        }

        &__content {
          color: $black;
          padding-bottom: 2rem;
          padding-left: 0rem;
        }

        &__image {
          height: 18.5rem;
          object-fit: cover;
          width: 20rem;
          padding-bottom: 1rem;
        }

        &__heading {
          font-size: 1.4rem;
          font-weight: 400;
          margin-bottom: 0.5em;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          line-height: 1.2;
        }

        &__description {
          font-size: 1.25rem;
          font-weight: 200;
          line-height: 1.2;
          letter-spacing: 0.05em;
        }
      }
    }    
  }

  &__cloud {
    position: absolute;
    top: 0;
    animation: cloud 90s linear infinite;
    opacity: 0.75;
    margin-top: -30rem;
  }

  &__heading {
    color: $lblue;
    font-size: 3.25rem;
    letter-spacing: 0.05em;
    line-height: 1.2;
    margin-bottom: 2rem;
    max-height: 13.2rem;
    position: relative;
    text-transform: uppercase;
    font-weight: 200;

    // &:after {
    //   background-color: $lblue;
    //   bottom: -1.5rem;
    //   content: '';
    //   position: absolute;
    //   height: 0.4rem;
    //   left: 0;
    //   width: 5rem;
    // }
  }

  &__description {
    font-size: 1.5rem;
    letter-spacing: 0.05em;
    line-height: 1.2;
    margin-bottom: 2em;
    max-height: 70rem;
    font-weight: 200;
  }  

  .sidebar__nav-item {
    transition: padding-left 0.3s;
    &.router-link-active, &--active {
      // border-top: 1px solid $lblue;
      // padding-left: 1em;
      color: $bottombar-text-color-active;
    }
  }
}

@keyframes cloud {
  0% { 
    left: 0;
    transform: translateX(-100%) rotate(0deg);
  }
  50% {
    left: 100%;
    transform: rotate(45deg);
  }
  100% {
    left: 100%;
    transform: translateX(100%) rotate(0deg);
  }
}
</style>
